/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Destination_EuInputs */

const en_reference_destination_eu = /** @type {(inputs: Reference_Destination_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

/**
* | output |
* | --- |
* | "EU" |
*
* @param {Reference_Destination_EuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_destination_eu = /** @type {((inputs?: Reference_Destination_EuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Destination_EuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_destination_eu(inputs)
});